import { Box } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { Loading } from '@/components/Loading'
import { LoadingFailedAlert } from '@/components/LoadingFailedAlert'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { MeetingRecordProvider } from '@/context/MeetingRecordProvider'
import OffersAddonProvider from '@/context/OffersAddonProvider'
import { SelectedOffersAddonProvider } from '@/context/SelectedOffersAddonProvider'
import { SelectedQuoteProvider } from '@/context/SelectedQuoteContext'
import { Note } from '../../../components/Note'
import { Steps } from '../../../components/Steps/Steps'
import { WizzardHeader } from '../../../components/WizzardHeader/WizzardHeader'
import { StepComplete } from '../../../containers/steps/vehicle/StepComplete'
import { SidebarProvider } from '../../../context/SidebarContext'
import { StepsProvider } from '../../../context/StepsContext'
import { WizzardHeaderProvider } from '../../../context/WizzardHeaderContext'
import { PageWrapper } from '../../../layouts/components/PageWrapper'
import { Sidebar } from '../../../layouts/components/Sidebar'

export const StepCompletePage = () => {
  const { isLoadingData, insuranceParamsId, error } = useInsuranceParams()

  const [noteText, setNoteText] = useState<string | undefined>(undefined)
  const [calculationState] = useState({
    isCalculated: false,
    isCalculating: false,
  })

  const handleCreateNote = () => {
    setNoteText('Nová poznámka')
  }

  useEffect(() => { }, [calculationState.isCalculated])

  return (
    <StepsProvider currentStepId={4}>
      <SidebarProvider>
        <WizzardHeaderProvider>
          {isLoadingData ? <Loading large /> : error ? <LoadingFailedAlert /> :
            <SelectedQuoteProvider >
              <OffersAddonProvider>
                <SelectedOffersAddonProvider>
                  <MeetingRecordProvider insuranceParamsId={insuranceParamsId!}>
                    <PageWrapper
                      steps={<Steps />}
                      header={<WizzardHeader onCreateNote={handleCreateNote} />}
                      sidebar={<Sidebar />}
                      contentProps={{
                        sx: {
                          pt: { base: 0, md: 0 },
                        },
                      }}
                    >
                      {noteText && noteText !== '' && (
                        <Note
                          date="11.10.2021 14:35"
                          text={noteText}
                          onChange={(text) => setNoteText(text)}
                        />
                      )}

                      <Box sx={{ pt: { base: 0, md: !noteText ? 8 : 0 } }}>
                        <StepComplete />
                      </Box>
                    </PageWrapper>
                  </MeetingRecordProvider>
                </SelectedOffersAddonProvider>
              </OffersAddonProvider>
            </SelectedQuoteProvider>
          }
        </WizzardHeaderProvider>
      </SidebarProvider>
    </StepsProvider>
  )
}